"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubformRemoveTool = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const image_button_1 = require("../../../components/button/image.button");
const icons_1 = require("../../../components/icon/icons");
const modal_service_1 = require("../../../components/modal/modal.service");
const i18n_1 = require("../../../i18n");
const services_1 = require("../../../services");
const page_state_1 = require("../../../state/page.state");
const point_collection_cache_1 = require("../../topological.editor.map/point.collection.cache");
class SubformRemoveTool {
    static view(ctrl, collection) {
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.DELETE, {
            title: i18n_1.T.COLLECTION_EDIT_DELETE_SUBFORM,
            titleAttrs: { title: collection.schema.displayName },
            onclick: (e) => SubformRemoveTool.removeSubFormInstance(ctrl, e, collection),
        });
    }
    static removeSubFormInstance(ctrl, e, c) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            e.stopPropagation();
            const response = yield modal_service_1.ModalService.open({
                title: (0, i18n_1.Translate)(i18n_1.T.SUBFORM_REMOVE_TITLE, { title: c.formTitle }),
                content: (0, i18n_1.Translate)(i18n_1.T.SUBFORM_REMOVE_CONFIRM, { title: c.schema.displayName }),
                okName: i18n_1.T.SUBFORM_REMOVE_REMOVE,
                hasCancel: true,
            });
            if (response.ok) {
                this.doRemoveSubFormInstance(ctrl, c);
            }
        });
    }
    static doRemoveSubFormInstance(ctrl, c) {
        page_state_1.CurrentState.cancelInteractions();
        c.parent.Mutator.remove(c.instanceId);
        // Update current capture if capture was removed with form (we dont update this if we are in TE)
        const captureIds = services_1.Services.Collection.getCaptureIds(c.collection);
        if (captureIds.indexOf(page_state_1.CurrentState.inspectedCaptureId) === -1 &&
            ctrl.kind !== 'TopologicalEditorCollectionEditCtrl') {
            page_state_1.CurrentState.inspectedCaptureId = null;
        }
        if (ctrl.kind === 'TopologicalEditorCollectionEditCtrl') {
            point_collection_cache_1.TopologicalPointCollectionCache.dropCollectionVectors(c.collection.revision);
        }
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'subform:delete', c.instanceId);
    }
}
exports.SubformRemoveTool = SubformRemoveTool;
tslib_1.__decorate([
    mobx_1.action
], SubformRemoveTool, "doRemoveSubFormInstance", null);
//# sourceMappingURL=subform.remove.tool.js.map